import React, { useEffect, useState } from "react";
import { Routes, useParams } from "react-router";
import useUserData from "../custom_hooks/useUserData";
import { Link } from "react-router-dom";
import CollapseHeader from "../core/common/collapse-header/collapse-header";
import { McitiImg } from "../utils/iconLogo";
import useApi from "../API/useApi";
import LoadingGreen from "./loading/LoadingGreen";

const BatchHeading: any = {
  lesson_plan: {
    navigateLink: "/add-lession-plan",
    heading: "Lesson Plan Management",
    subheading: "Select a Batch to Add a Lesson Plan",
  },
  attendence: {
    navigateLink: "/add-attendance",
    heading: "Attendance Management",
    subheading: "Select a Batch to Mark Attendance",
  },
  assessment: {
    navigateLink: "/add-assessments",
    heading: "Assessment Management",
    subheading: "Select a Batch to Assign the Assessment",
  },
  submission: {
    navigateLink: "/submission",
    heading: "Submission Management",
    subheading: "Select a Batch to Review Submissions",
  },
  start_training: {
    navigateLink: "/start-training",
    heading: "Training Overview",
    subheading: "Select a Batch to View Training",
  },
  // view_units: {
  //   navigateLink: "/select-unit",
  //   heading: "Study Plan Overview",
  //   subheading: "Select a Batch to Begin Learning",
  // }
};

function GetBatches() {
  const { module } = useParams<{ module: any }>();
  // console.log(module, "paramss............");
  const [selectedBatch, setSelectedBatch] = useState(null);
  const { employee_id, school_code, course } = useUserData();
  // console(employee_id, school_code);

  // const [batchData, setBatchData] = useState([])

  // const getBatches = async () => {
  //   const resp = await axiosInstance.post(webserviceUrl.get_batches, { employee_id, school_code })
  //   // console(resp?.data);
  //   setBatchData(resp?.data?.data || [])
  // }

  // const token = localStorage.getItem("token");

  // const getBatches = async () => {
  //   try {
  //     const response = await axios.post(
  //       webserviceUrl.get_batches,
  //       {
  //         employee_id,
  //         school_code,
  //       },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     const data = response?.data?.data || [];
  //     console.log('Batch Data:', data);
  //   } catch (error) {
  //     console.error('Error fetching batches:', error);
  //   }
  // };

  // useEffect(() => {
  //   getBatches()
  // }, [])

  // useEffect(() => {
  //   console.log("api call");
  //   getBatches()
  // }, [])

  // **************************** Support Team
  const {
    data: SupportTeamData,
    loading: SupportTeamLoading,
    error: SupportTeamError,
    callApi: getAdvanseData,
  } = useApi("/get_batches", {
    method: "POST",
    autoCall: false, // disable auto call
  });

  useEffect(() => {
    if (!school_code) return; // safety check

    getAdvanseData({
      employee_id,
      school_code,
    });
  }, [school_code]); // add school_code as dependency

  useEffect(() => {
    console.log(SupportTeamData?.data, "SupportTeamData");
  }, [SupportTeamData]);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-4">
            <div className="my-auto mb-2">
              <h2 className="mb-1">
                {" "}
                {module ? BatchHeading[module]?.heading : ""}{" "}
              </h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    {/* <Link to={Routes.}> */}
                    <Link to={"/"}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item text-capitalize">
                    {module ? module : ""}
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {module ? BatchHeading[module]?.heading : ""}
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>

          {/* 🔥 Loader */}
          {SupportTeamLoading && <LoadingGreen height="85vh" />}

          {/* Batch Cards */}
          {!SupportTeamLoading && (
            <div className="row p-0 px-2">
              {SupportTeamData?.data.map((batch: any, index: number) => (
                <>
                  <div className="px-3 py-4 rounded-3 bg-white border border-secondary-subtle ">
                    <h5 className="" style={{}}>
                      {module
                        ? BatchHeading[module]?.subheading
                        : "Select Batch"}
                    </h5>
                  </div>
                  <div
                    className="col-md-5 col-lg-4 px-1 mb-4 mt-4 "
                    key={index}
                  >
                    {/* <Link to={module ? BatchHeading[module]?.navigateLink : '/'}
                        onClick={() => {
                          localStorage.setItem("batch", btoa(JSON.stringify(batch)))
                          setSelectedBatch(batch)
                        }}
                        className="card h-100 shadow-sm text-decoration-none"
                      > */}
                    <Link
                      to={module ? BatchHeading[module]?.navigateLink : "/"}
                      onClick={() => {
                        // Save batch in localStorage
                        localStorage.setItem(
                          "batch",
                          btoa(JSON.stringify(batch)),
                        );
                        setSelectedBatch(batch);

                        // 🔥 Log details
                        const navigateUrl = module
                          ? BatchHeading[module]?.navigateLink
                          : "/";
                        // console.log("✅ Card Clicked!");
                        // console.log("✅ Card Clicked!", module);
                        // console.log("👉 Navigating to:", navigateUrl);
                        // console.log("👉 Batch Selected:", batch);
                      }}
                      className="card h-100 shadow-sm text-decoration-none"
                    >
                      <div className="card-body d-flex align-items-center">
                        <div className="me-3">
                          <i
                            className="ti ti-users"
                            style={{ fontSize: "50px", color: "#509839" }}
                          ></i>
                        </div>
                        <div>
                          <h5 className="mb-1 text-dark">
                            {batch.course_name}
                          </h5>
                          <p className="text-muted small mb-0">{batch.class}</p>
                        </div>
                      </div>
                    </Link>
                  </div>
                </>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="footer d-smflex d-flex align-items-center justify-content-center border-top bg-white p-3 pb-0 pt-2">
          <p className="mb-0">
            Organized by IHFC, IIT
            {/* <img
              src={McitiImg}
              alt="Mciti Logo"
              className="ms-2 "
              style={{
                height: "40px",
                width: "40px",
                objectFit: "contain",
              }}
            /> */}
          </p>
          {/* <p className="mb-0"> © {new Date()?.getFullYear()} IHFC. All rights reserved.</p> */}
        </div>
      </div>
    </div>
  );
}

export default GetBatches;
